module.exports = __webpack_public_path__ + "static/media/youtube.fb769c22.svg";